import React from "react";
import { Participant as IParticipant } from "twilio-video";
import ParticipantTracks from "../ParticipantTracks/ParticipantTracks";
import ParticipantInfo from "../ParticipantInfo/ParticipantInfo";

interface IParticipantProps {
  participant: any;
  videoOnly?: boolean;
  enableScreenShare?: boolean;
  onClick?: () => void;
  isSelected?: boolean;
  isLocalParticipant?: boolean;
  hideParticipant?: boolean;
  room: any;
}

const Participant: React.FC<IParticipantProps> = ({
  participant,
  videoOnly,
  enableScreenShare,
  onClick,
  isSelected,
  isLocalParticipant,
  hideParticipant,
  room,
}) => {
  return (
    <ParticipantInfo
      participant={participant}
      onClick={onClick}
      isSelected={isSelected}
      isLocalParticipant={isLocalParticipant}
      hideParticipant={hideParticipant}
      room={room}
    >
      <ParticipantTracks
        participant={participant}
        videoOnly={videoOnly}
        enableScreenShare={enableScreenShare}
        isLocalParticipant={isLocalParticipant}
      />
    </ParticipantInfo>
  );
};

export default Participant;
